import React from 'react';
import Icon from '@/components/ui/AppIcon';

const transactions = [
  { id: 'txn-001', desc: 'Caramel Latte Grande', store: 'Taksim', date: '17 Tem 2026, 09:14', amount: -89, type: 'purchase' },
  { id: 'txn-002', desc: 'Kart Yükleme', store: 'Uygulama', date: '15 Tem 2026, 18:30', amount: +100, type: 'reload' },
  { id: 'txn-003', desc: 'Hazelnut Latte + Kruvasan', store: 'Nişantaşı', date: '14 Tem 2026, 08:45', amount: -130, type: 'purchase' },
  { id: 'txn-004', desc: 'Kart Yükleme', store: 'Uygulama', date: '12 Tem 2026, 20:10', amount: +200, type: 'reload' },
  { id: 'txn-005', desc: 'Cold Brew Venti', store: 'Beşiktaş', date: '11 Tem 2026, 10:22', amount: -95, type: 'purchase' },
  { id: 'txn-006', desc: 'Caramel Chiller + Cheesecake', store: 'Kadıköy', date: '09 Tem 2026, 15:05', amount: -164, type: 'purchase' },
  { id: 'txn-007', desc: 'eHediye Alındı', store: 'Zeynep Arslan', date: '07 Tem 2026, 12:00', amount: +50, type: 'gift' },
];

export default function TransactionHistory() {
  return (
    <div>
      <h3 className="text-foreground font-bold text-base mb-3">İşlem Geçmişi</h3>
      <div className="bg-card rounded-2xl card-shadow overflow-hidden">
        {transactions?.map((txn, idx) => (
          <div
            key={txn?.id}
            className={`flex items-center gap-3 px-4 py-3 ${idx < transactions?.length - 1 ? 'border-b border-border' : ''}`}
          >
            <div
              className={`w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${
                txn?.type === 'reload' ?'bg-green-100'
                  : txn?.type === 'gift' ?'bg-gold-light' :'bg-muted'
              }`}
            >
              {txn?.type === 'reload' ? (
                <Icon name="PlusCircleIcon" size={18} className="text-primary" />
              ) : txn?.type === 'gift' ? (
                <Icon name="GiftIcon" size={18} className="text-gold" />
              ) : (
                <Icon name="ShoppingBagIcon" size={18} className="text-muted-foreground" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-foreground font-semibold text-sm truncate">{txn?.desc}</p>
              <p className="text-muted-foreground text-xs">{txn?.store} · {txn?.date}</p>
            </div>
            <span
              className={`font-bold text-sm font-tabular flex-shrink-0 ${
                txn?.amount > 0 ? 'text-primary' : 'text-foreground'
              }`}
            >
              {txn?.amount > 0 ? '+' : ''}₺{Math.abs(txn?.amount)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}